import { h } from 'preact'
import Icon from 'components/Icon'

export function renderChatChannelAvatarValue(imageUrl) {
  if (typeof imageUrl === 'string' && imageUrl.startsWith('#'))
    return <div className="avatarImg" style={{ backgroundColor: imageUrl }}>
      <Icon type="chaty" />
    </div>

  if (typeof imageUrl === 'string' && imageUrl)
    return <img
      src={imageUrl}
      alt="Chat Image"
      className="avatarImg"
      style={{ padding: 0 }}
    />

  return <div className="avatarImg" style={{ backgroundColor: '#B4B7BB' }}>
    <Icon type="chaty" />
  </div>
}
